import { v4 as uuidv4 } from 'uuid';
import { UserOffline } from '../../interfaces/Offline';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import OfflineController from '@/assets/ts/controller/OfflineController';

class UserRepository {

  public static async getUser(showLoading = true): Promise<UserOffline> {
    try {
      const db = OfflineController.getDB();
      const user = await new Promise<any[]>((resolve, reject) => {
        db.transaction((tx) => {
          tx.executeSql('SELECT * FROM USER', [], (tx, res) => {
            const userRow = [];
            for (let i = 0; i < res.rows.length; i++) {
              userRow.push(res.rows.item(i));
            }
            resolve(userRow);
          });
        });
      });

      return user[0];
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async setUser(
    user: UserOffline,
    showLoading = true
  ): Promise<any> {
    try {
      const NRUSER = uuidv4();

      const {
        NRVINCULOM,
        NMOPERADOR,
        NRORG,
        NRPARCNEGOCIO,
        CDOPERADOR,
        dp: ISDP,
        IDEXIGEFOTOREGPNTPG,
        IDPGRESTRINGETELAREGIST
      } = user;

      const db = OfflineController.getDB();
      const result = await new Promise((resolve, reject) => {
        document.addEventListener('deviceready', () => {
          db.transaction(
            (tx) => {
              tx.executeSql(
                `INSERT INTO USER (
                  NRUSER, 
                  NRVINCULOM, 
                  NMOPERADOR, 
                  NRORG, 
                  NRPARCNEGOCIO, 
                  CDOPERADOR, 
                  ISDP, 
                  IDEXIGEFOTOREGPNTPG, 
                  IDPGRESTRINGETELAREGIST
                ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                [
                  NRUSER,
                  NRVINCULOM,
                  NMOPERADOR,
                  NRORG,
                  NRPARCNEGOCIO,
                  CDOPERADOR,
                  ISDP,
                  IDEXIGEFOTOREGPNTPG,
                  IDPGRESTRINGETELAREGIST
                ]
              );
            },
            (error) => {
              reject(error);
            },
            () => {
              resolve(true);
            }
          );
        });
      });

      return result;
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async deleteUser(showLoading = true): Promise<any> {
    try {
      const db = OfflineController.getDB();
      const deleteVinculo = await new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            tx.executeSql('DELETE FROM USER');
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve('');
          }
        );
      });

      return deleteVinculo;
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }
}

export default UserRepository;
